import { useContext } from "react"
import { FavouriteContext } from "../providers/FavouriteProvider"

export const useFavourite = (id?:number) => {
  const context = useContext(FavouriteContext)

  return {
    ...context,
    isFavourite: context.ids?.includes(id),
  }
}

// export const useFavourite = id => useContext(FavouriteContext)
